import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ReportGridService } from '@app/shared/report/report-grid.service';
import { ReportGrid } from '@app/shared/report/report-grid';
import { ChartCreationType, ChartService, IChartGridContext } from '@app/main/report/chart/chart.service';

@Component({
  selector: 'full-chart-dialog',
  template: `
    <default-dialog [title]="title" [closeButton]="true">
      <div [id]="chartId" class="chart-container"></div>
    </default-dialog>
  `
})
export class FullChartDialogComponent implements OnInit, AfterViewInit {
  @Input() public title:string;
  @Input() public gridId:string;
  @Input() public currency:string;
  
  public chartId:string;

  constructor(
    private reportGridService:ReportGridService,
    private chartService:ChartService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.chartId = `DIALOG_${this.gridId}_CHART`;
  }

  // we need to create the chart in `AfterViewInit` because we need to wait until dialog element fully rendered
  public ngAfterViewInit():void {
    const reportGrid:ReportGrid = this.reportGridService.getReportGrid(this.gridId);
    const gridContext:IChartGridContext = reportGrid.api.getGridOption('context');
    
    switch (gridContext.chartCreationType) {
      case ChartCreationType.RANGE:
        this.chartService.createGroupedColumnChart(reportGrid.api, this.chartId, this.currency);
        break;
      case ChartCreationType.PIVOT:
        this.chartService.createPivotChart(reportGrid.api, this.chartId);
        break;
    }
  }
}